import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntityListComponent } from './entity-list.component';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { FuseSharedModule } from '@fuse/shared.module';




@NgModule({
  declarations: [EntityListComponent],
  imports: [
    CommonModule,
    MatListModule,
    MatFormFieldModule,
    MatInputModule,
    FuseSharedModule,
    //RouterModule,
    MatDividerModule
  ],
  exports: [EntityListComponent]
})
export class EntityListModule { }
